// Helpers.
import { CALL_STATES, CALL_MEDIA_STATES } from '../constants'

/**
 * Retrieves the current state of media flow based on a call's state.
 * @method getMediaState
 * @param  {Object} callState A call's state.
 * @return {string} A CALL_MEDIA_STATES enum value.
 */
export function getMediaState (callState) {
  if (hasMedia(callState)) {
    return CALL_MEDIA_STATES.CONNECTED
  } else if (isLocalHold(callState)) {
    return CALL_MEDIA_STATES.LOCAL_HOLD
  } else if (isRemoteHold(callState)) {
    return CALL_MEDIA_STATES.REMOTE_HOLD
  } else if (isDualHold(callState)) {
    return CALL_MEDIA_STATES.DUAL_HOLD
  }
}

/**
 * Checks whether the call state indicates that the call has media.
 * @method hasMedia
 * @param  {Object}  callState Redux call state.
 * @return {boolean}
 */
export function hasMedia (callState) {
  return callState.state === CALL_STATES.CONNECTED && !callState.localHold && !callState.remoteHold
}

/**
 * Checks whether the call state indicates that the call is locally held (only).
 * @method isLocalHold
 * @param  {Object}  callState Redux call state.
 * @return {boolean}
 */
export function isLocalHold (callState) {
  return callState.state === CALL_STATES.ON_HOLD && callState.localHold && !callState.remoteHold
}

/**
 * Checks whether the call state indicates that the call is remotely held (only).
 * @method isRemoteHold
 * @param  {Object}  callState Redux call state.
 * @return {boolean}
 */
export function isRemoteHold (callState) {
  return callState.state === CALL_STATES.ON_HOLD && !callState.localHold && callState.remoteHold
}

/**
 * Checks whether the call state indicates that the call is both locally and
 *    remote held.
 * @method isDualHold
 * @param  {Object}  callState Redux call state.
 * @return {boolean}
 */
export function isDualHold (callState) {
  return callState.state === CALL_STATES.ON_HOLD && callState.localHold && callState.remoteHold
}
